'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.default = mapConnect;

var _ramda = require('ramda');

var _ = require('.');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mapConnect(state, obj) {

  var props = (0, _keys2.default)(obj);
  var strs = (0, _ramda.values)(obj);
  var reducerData = {};

  return strs.reduce(function (data, oriStr, index) {

    var func = void 0;
    var str = oriStr;

    if ((0, _.isFunction)(str)) {
      data[props[index]] = str();
      return data;
    }

    if ((0, _.isPlainObject)(str)) {
      func = str.func;
      str = str.str;
    }

    var _str$split = str.split('.'),
        _str$split2 = (0, _slicedToArray3.default)(_str$split, 2),
        reducerName = _str$split2[0],
        reducerProp = _str$split2[1];

    if (!(reducerName in reducerData)) {
      reducerData[reducerName] = state[reducerName].toJS();
    }

    if ((0, _.isFunction)(func)) {
      data[props[index]] = func(reducerData[reducerName][reducerProp]);
    } else {
      data[props[index]] = reducerData[reducerName][reducerProp];
    }

    return data;
  }, {});
}
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/helpers/mapConnect.js
 ** module id = 1243
 ** module chunks = 0
 **/